import { BaseModel } from "./base-model"

export class StateOrderModel extends BaseModel {
  name: string = ""

  constructor(params: any = null) {
    super(params)
    this.copyFromObject(params)
  }

  static override newModel(params: any = null): StateOrderModel {
    return new StateOrderModel(params)
  }
}
